import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function LPowerSeries({ data }: any) {
    const { Link } = useGlobal();
    const { key, title, desc, img, tables, note } = data;
    return (
        <div id={`vanlife-L-smart-series-${key}`} className={`vanlife-L-smart-series vanlife-L-smart-series-${key} ${css['vanlife-L-smart-series']}`}>
            <h4 className="title">{title}</h4>
            <div className="img-box">
                <EFPicture src={img} alt={title} />
            </div>
            <p className="text desc-h4">{desc}</p>
            <ul className="grid-box">
                {tables?.map((table: any) => (
                    <li className="grid-item" key={`${key}_${table?.tableTitle}`}>
                        <h5 className="table-title">{table?.tableTitle}</h5>
                        <table className="item-table" border={1}>
                            {table?.tableHead && (
                                <thead className="thead">
                                    <tr className="tr">
                                        {table?.tableHead?.map((head: any, k: number) => (
                                            <th className={`th td ${k === 0 ? 'menu' : ''}`} key={`${key}_${head?.text}`}>
                                                {head?.link ? (
                                                    <Link className="head-link" href={head?.link}>
                                                        {head?.text}
                                                    </Link>
                                                ) : (
                                                    head?.text
                                                )}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                            )}
                            <tbody className="tbody">
                                {table?.tableContent?.map((row: any, _: number) => (
                                    <tr className="tr" key={`${key}_${row[0]}`}>
                                        {row?.map((col: any, m: number) => (
                                            <td className={`td ${m === 0 ? 'menu' : ''}`} key={`${key}_${row[0]}_${col}`}>
                                                {col}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </li>
                ))}
            </ul>
            {note && <p className="caption caption-note">{note}</p>}
        </div>
    );
}
